import React, { FC } from 'react'

import { IconMobilesProps } from './IconMobiles.types'
import * as Styled from './styles/IconMobiles.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMobiles: FC<IconMobilesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMobilesProps['size'],
  isResponsive = false,
}: IconMobilesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M14 39.11h6' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='m23.5 42.868-12.92.11c-1.975 0-3.577-1.713-3.577-3.688V12.618a3.577 3.577 0 0 1 3.575-3.578h16.5v30.25a3.577 3.577 0 0 1-3.578 3.578v0Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M30 35.165h3.903' stroke='#E60000' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path
          d='M20.902 8.673a3.575 3.575 0 0 1 3.578-3.578h16.5v30.25a3.578 3.578 0 0 1-3.577 3.578l-10.045.082'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMobiles
